import { useRef, useEffect, useState } from 'react'

export default () => {
  const zdassetsScriptContainer = useRef(null)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    if (!zdassetsScriptContainer.current) return
    if (mounted) return

    const zdassetsScript = document.createElement('script')
    zdassetsScript.src = 'https://static.zdassets.com/ekr/snippet.js?key=fca886fa-ff65-42e6-a505-28c29e35856b'
    zdassetsScript.defer = true
    zdassetsScript.id = 'ze-snippet'
    zdassetsScriptContainer.current.appendChild(zdassetsScript)

    setMounted(true)
  }, [zdassetsScriptContainer])

  return { zdassetsScriptContainer }
}
